/* eslint n/no-unsupported-features/es-syntax:0 -- ignore */
import { Linter } from "../../node_modules/eslint/lib/linter/index.js"
export { Linter }
export default { Linter }
